import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpApiService } from '@recruitee/http';
import { User } from '@recruitee/http-types';

@Injectable({ providedIn: 'root' })
export class UserHttpClient {
  constructor(protected httpApi: HttpApiService) {}

  public fetchCollection(): Observable<User[]> {
    return this.httpApi.get('/admins').pipe(map(response => response.admins));
  }
}
